<template>
    <div class="page-container">
        <!-- 搜索区域 -->
        <el-card class="box-card">
            <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                <el-form-item label="版本号">
                    <el-input
                        clearable
                        v-model="queryParams.versionName"
                        placeholder="请输入版本号"
                        style="width: 200px;">
                    </el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select
                        v-model="queryParams.status"
                        placeholder="请选择状态"
                        clearable
                        style="width: 150px;">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="停用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="btnSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="btnReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <div style="height: 10px;"></div>

        <!-- 表格区域 -->
        <el-card class="box-card">
            <el-button
                type="success"
                icon="el-icon-plus"
                @click="handleAdd(null)"
                size="mini"
                plain>
                新增版本
            </el-button>

            <div style="height: 10px;"></div>

            <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="versionName" label="版本号" width="120" align="center"></el-table-column>
                <el-table-column prop="downloadUrl" label="文件地址" min-width="300" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link
                            type="primary"
                            :href="scope.row.downloadUrl"
                            target="_blank"
                            v-if="scope.row.downloadUrl">
                            {{scope.row.downloadUrl}}
                        </el-link>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="packageSize" label="文件大小" width="120" align="center">
                    <template slot-scope="scope">
                        {{ formatFileSize(scope.row.packageSize) }}
                    </template>
                </el-table-column>
                <el-table-column prop="updateContent" label="升级内容" min-width="250" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-html="scope.row.updateContent || '-'"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
                            {{ scope.row.status === 1 ? '启用' : '停用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="160" align="center"></el-table-column>
                <el-table-column align="center" label="操作" width="180" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row)">
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            style="color: #f56c6c;"
                            @click="handleDelete(scope.row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                style="margin-top:10px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize"
                :current-page="queryParams.currentPage"
                :total="total">
            </el-pagination>
        </el-card>

        <!-- 新增/编辑弹窗 -->
        <el-dialog
            :title="form.id ? '编辑版本' : '新增版本'"
            :visible.sync="dialogVisible"
            width="700px"
            :close-on-click-modal="false">
            <el-form :model="form" ref="form" label-width="120px" :rules="rules">
                <el-form-item label="版本号" prop="versionName">
                    <el-input
                        v-model="form.versionName"
                        placeholder="请输入版本号，如：1.0.0"
                        clearable>
                    </el-input>
                    <div style="color: #909399; font-size: 12px; margin-top: 5px;">
                        建议使用语义化版本号格式：主版本号.次版本号.修订号
                    </div>
                </el-form-item>

                <el-form-item label="文件地址" prop="downloadUrl">
                    <single-file-upload
                        v-model="form.downloadUrl"
                        accept=".apk,.ipa,.wgt,.zip,.rar"
                        :max-size="500"
                        tips="支持 APK、IPA、WGT、ZIP、RAR 格式，文件大小不超过 500MB"
                        @success="handleUploadSuccess"
                        @clear="handleUploadClear">
                    </single-file-upload>
                </el-form-item>

                <el-form-item label="文件大小">
                    <div class="file-size-display">
                        {{ formatFileSize(form.packageSize) }}
                    </div>
                    <div style="color: #909399; font-size: 12px; margin-top: 5px;">
                        文件大小将在上传后自动获取
                    </div>
                </el-form-item>

                <el-form-item label="升级内容" prop="updateContent">
                    <el-input
                        v-model="form.updateContent"
                        type="textarea"
                        placeholder="请输入升级内容说明"
                        :autosize="{minRows: 4, maxRows: 8}"
                        maxlength="2000"
                        show-word-limit>
                    </el-input>
                </el-form-item>

                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="form.status">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">停用</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input
                        v-model="form.remark"
                        type="textarea"
                        placeholder="请输入备注信息"
                        :autosize="{minRows: 2, maxRows: 4}"
                        maxlength="500"
                        show-word-limit>
                    </el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="handleSubmit('form')" :loading="submitLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    reqPageVersion,
    reqInsertVersion,
    reqUpdateVersion,
    reqDeleteVersion
} from "@/api/system/app-version";
import SingleFileUpload from "@/components/core/upload/SingleFileUpload.vue";
import global from "@/api/global";

export default {
    name: 'AppVersion',

    components: {
        SingleFileUpload
    },

    async created() {
        await this.loadData();
    },

    methods: {
        // 加载数据
        async loadData() {
            this.loading = true;
            try {
                const res = await reqPageVersion(this.queryParams);
                this.tableData = res.records || [];
                this.total = res.total || 0;
            } catch (error) {
                this.$message.error('加载数据失败');
            } finally {
                this.loading = false;
            }
        },

        // 查询
        async btnSearch() {
            this.queryParams.currentPage = 1;
            await this.loadData();
        },

        // 重置
        async btnReset() {
            this.queryParams = {
                currentPage: 1,
                pageSize: 10,
                versionName: '',
                status: null
            };
            await this.loadData();
        },

        // 页码改变
        handleCurrentChange(page) {
            this.queryParams.currentPage = page;
            this.loadData();
        },

        // 每页条数改变
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.currentPage = 1;
            this.loadData();
        },

        // 生成下一个版本号
        generateNextVersion() {
            if (!this.tableData || this.tableData.length === 0) {
                return '1.0.0';
            }

            // 获取所有有效的版本号
            const versions = this.tableData
                .map(item => item.versionName)
                .filter(v => v && /^\d+\.\d+\.\d+$/.test(v))
                .map(v => {
                    const parts = v.split('.').map(Number);
                    return {
                        major: parts[0],
                        minor: parts[1],
                        patch: parts[2],
                        original: v
                    };
                });

            if (versions.length === 0) {
                return '1.0.0';
            }

            // 找到最大的版本号（按主版本、次版本、修订号排序）
            versions.sort((a, b) => {
                if (a.major !== b.major) return b.major - a.major;
                if (a.minor !== b.minor) return b.minor - a.minor;
                return b.patch - a.patch;
            });

            const maxVersion = versions[0];

            // 递增修订号
            return `${maxVersion.major}.${maxVersion.minor}.${maxVersion.patch + 1}`;
        },

        // 新增
        handleAdd() {
            const nextVersion = this.generateNextVersion();
            this.form = {
                versionName: nextVersion,
                downloadUrl: '',
                packageSize: null,
                updateContent: '',
                status: 1,
                remark: ''
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },

        // 编辑
        handleEdit(row) {
            this.form = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },

        // 关闭弹窗
        closeDialog() {
            this.dialogVisible = false;
            this.form = {};
        },

        // 提交表单
        async handleSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.submitLoading = true;
                    try {
                        if (this.form.id) {
                            await reqUpdateVersion(this.form);
                            this.$message.success('更新成功');
                        } else {
                            await reqInsertVersion(this.form);
                            this.$message.success('新增成功');
                        }
                        this.closeDialog();
                        await this.loadData();
                    } catch (error) {
                        this.$message.error(error.message || '操作失败');
                    } finally {
                        this.submitLoading = false;
                    }
                }
            });
        },

        // 删除
        handleDelete(id) {
            this.$confirm("此操作将永久删除该版本记录, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                try {
                    await reqDeleteVersion(id);
                    this.$message.success("删除成功");
                    await this.loadData();
                } catch (error) {
                    this.$message.error(error.message || '删除失败');
                }
            }).catch(() => {});
        },

        // 格式化文件大小
        formatFileSize(bytes) {
            if (!bytes || bytes === 0) return '-';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
        },

        // 文件上传成功回调
        handleUploadSuccess({ url, file }) {
            // 自动设置文件大小
            if (file && file.size) {
                this.form.packageSize = file.size;
            }
        },

        // 文件清除回调
        handleUploadClear() {
            // 清除文件大小
            this.form.packageSize = null;
        }
    },

    data() {
        return {
            fileUrl:global.preview_path_url,
            loading: false,
            submitLoading: false,
            queryParams: {
                currentPage: 1,
                pageSize: 10,
                versionName: '',
                status: null
            },
            tableData: [],
            total: 0,
            dialogVisible: false,
            form: {},
            rules: {
                versionName: [
                    { required: true, message: '请输入版本号', trigger: 'blur' },
                    {
                        pattern: /^\d+\.\d+\.\d+$/,
                        message: '版本号格式不正确，应为：1.0.0',
                        trigger: 'blur'
                    }
                ],
                downloadUrl: [
                    { required: true, message: '请输入文件地址', trigger: 'blur' }
                ],
                updateContent: [
                    { required: true, message: '请输入升级内容', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            }
        };
    }
};
</script>

<style scoped>
.page-container {
    padding: 20px;
}

.box-card {
    margin-bottom: 10px;
}

.demo-form-inline .el-form-item {
    margin-bottom: 0;
}

.file-size-display {
    padding: 8px 12px;
    background-color: #f5f7fa;
    border-radius: 4px;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
}
</style>
